<template>
  <b-container style="margin-top: 175px" fluid="sm">
    <template v-if="user">
      <template v-if="(profile && invitation && invitation.rec) && invitation.rec.email === profile.email">
        <div v-if="invitation && invitationState === 'initial'">
            <invite-notice
                style="margin-bottom: 25px;"
                :invitation="invitation"
                @invitation-response="handleInvitationResponse"
            />
        </div>
        <div v-else-if="invitation && invitationState === 'accepted'" >
              <invite-acceptance-response
                  :invitation="invitation"
              />
        </div>
        <template v-else-if="invitation && invitationState === 'rejected'">
          <invite-rejection-response
              :invitation="invitation"
          />
        </template>
        <div v-else-if="invitation && invitationState === 'complete'" >
          <template v-if="userHasAccepted">
            <invite-acceptance-response
                :invitation="invitation"
            />
          </template>
          <template v-else>
            <invite-rejection-response
                :invitation="invitation"
            />
          </template>
        </div>
        <div v-else>
          <spinner>
            Searching for your invitation, standby
          </spinner>
        </div>
      </template>
      <template v-else>
        <h2>Invalid Invite- please use email it was assigned to</h2>
      </template>
    </template>
    <template v-else>
      <h2>Please sign in now</h2>
    </template>

    <Form :modal-show="openForm"/>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
import  InviteNotice from "./inviteNotice";
import  InviteAcceptanceResponse from "./inviteAcceptanceResponse";
import  InviteRejectionResponse from "./inviteRejectionResponse";
import moment from "moment";
import Form from "@/components/layout/Form";
export default {
  name: "Family_Invite",
  mixins: [RecordViews],
  components: {
    Form,
    InviteNotice,
    InviteAcceptanceResponse,
    InviteRejectionResponse
  },
  beforeMount() {
    this.inviteCode = this.$route.params.inviteCode;
  },
  mounted() {
    if (this.user) {
      this.getInvitationData();
      this.getProfile();
    }else{
        debugger
        this.openForm = true;
    }
  },
  watch: {
    user(newValue, oldValue) {
      debugger;
      if (newValue.uid) {
        this.getProfile();
        this.openForm = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile:"user/profile"
    }),
    heartBeatName() {
      return this.invitation  && this.invitation.heartbeat && this.invitation.heartbeat.name ?
          this.invitation.heartbeat.name
          : null;
    },
    heartBeatImgURL() {
      return this.invitation  && this.invitation.heartbeat && this.invitation.heartbeat.imgURL ?
          this.invitation.heartbeat.imgURL
          : null;
    },
    recipientNickname() {
      return this.invitation  && this.invitation.rec && this.invitation.rec.nickname ?
          this.invitation.rec.nickname
          : null;
    },
    expiration() {
      return this.invitation  && this.invitation._expire_at ?
          this.formatDate(this.invitation._expire_at)
          : null;
    },
  },
  methods: {
    getProfile() { //Must get invite after profile data in order to check email
      this.$store.dispatch("user/getProfile", "").then( profile =>{
        this.getInvitationData(profile);
      });
    },
    getInvitationData(profile) {
      this.$store
          .dispatch("heartbeats/getInviteByCode",{ inviteCode: this.inviteCode, email:profile ?
                profile.email : null})
          .then(res => {
            if (res) {
              this.invitation = res;
              this.recordView(this.invitation.id);
            }
            else
            {
              this.handleNoInviterData();
            }
          })
          .catch(e => {
            console.log(e);
          });
    },
    handleNoInviterData() {
      this.$router.push("/");
    },
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "invites",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
    handleInvitationResponse(hasAccepted){
      this.userHasAccepted = hasAccepted;
      this.invitationState = hasAccepted ? 'accepted':'rejected';
      this.$store
          .dispatch("heartbeats/responseToInvite",{
            reqUID: this.invitation.reqUID,
            profile: this.profile,
            inviteCode: this.invitation.inviteCode,
            hasAccepted: hasAccepted
          })
          .then(res => {
            if (res) {
              //update- invalidate Invite
              let updatedBy = this.profileBy();
              this.$store
                  .dispatch("heartbeats/updateFamilyInvite",{
                    inviteDocId:  this.invitation.docId,
                    status: hasAccepted ? 'accepted' : 'rejected',
                    updatedBy: updatedBy
                  }).then((res)=> {
                    this.invitationState= 'complete';
              });
            }
            else
            {
              //this.handleNoInviterData();
            }
          })
          .catch(e => {
            console.log(e);
          });
    },
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    },
    profileBy() {
      return {
        uid: this.profile.userId,
        name: `${this.profile.firstname} ${this.profile.lastname}`,
        imgURL: this.profile.imgURL
      };
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      userHasAccepted: null,
      openForm: false,
      mainProps: { blank: false, width: 100, height: 100, class: 'm1' },
      invitation: null,
      invitationState:'initial', //initial/rejected/approved
      inviteCode: null,
    };
  },
};
</script>
